export default "__VITE_ASSET__CJhhj23L__"